export type PollingExperiment = {
  experimentName: string;
  pageName: string;
};

// active survey-thanks polling experiments: https://admin.surveymonkey.com/experiments/polling
// @todo: add device and experiment info to url  https://momentiveai.atlassian.net/browse/ANONWEB-5463
export const PollingExperiments: PollingExperiment[] = [
  {
    // https://admin.surveymonkey.com/experiments/polling/1714
    experimentName: 'au_polling_endpage_exp',
    pageName: 'PollingAustraliaMap',
  },
  {
    // https://admin.surveymonkey.com/experiments/surveymonkey/418
    experimentName: 'canada_survey_research_exp',
    pageName: 'PollingCanadaMap',
  },
  {
    // https://admin.surveymonkey.com/experiments/polling/592
    experimentName: 'continuous_national_polling',
    pageName: 'PollingUSMap',
  },
  {
    // https://admin.surveymonkey.com/experiments/polling/1961
    experimentName: 'polling_gb_sct',
    pageName: 'PollingScotlandMap',
  },
  {
    // https://admin.surveymonkey.com/experiments/polling/1075
    experimentName: 'national_survey_ctm_benchmark_v2',
    pageName: 'PollingUSMap',
  },
  {
    // https://admin.surveymonkey.com/experiments/polling/573
    experimentName: 'uk_polling_endpage_exp',
    pageName: 'PollingUKMap',
  },
  {
    // https://admin.surveymonkey.com/experiments/polling/2189
    experimentName: 'upenn_polling_endpage_exp',
    pageName: 'PollingUPenn',
  },
];
